import { Divider } from "@/components/atoms/Divider";
import { cn } from "@/lib/utils";
import * as React from "react";

export type BookingSummaryCardProps = {
  className?: string;
  listingSummary: React.ReactNode;
  priceSummary: React.ReactNode;
};

export const BookingSummaryCard = ({
  className,
  listingSummary,
  priceSummary,
}: BookingSummaryCardProps) => {
  return (
    <div
      className={cn(
        "tw-bg-base-white tw-border-gray-300 tw-border tw-p-16 tw-w-full tw-rounded-4",
        className,
      )}
    >
      {listingSummary}

      {!!(listingSummary && priceSummary) && <Divider spacing={16} />}

      {priceSummary}
    </div>
  );
};
